import { Component, HostBinding, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import * as applicationConstants from '@app/constants/application-constants';
import { ONLINE_TERMS_URL } from '@app/constants/application-constants';
import { pageAnimation } from '@app/core/animations/element.animations';
import { AuthService } from '@app/services/auth.service';
import { ActionSettingsChangeHideMainMenu } from '@app/settings/store/settings.actions';
import * as fromApp from '@app/store/app.reducers';
import {
    SetLoggedInContactTCPortalAccepted
} from '@app/store/labsys-contact/labsys-contact.actions';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AcceptTermsAndConditions } from '@app/contact-profile/store/contact-profile.actions';
import { getIsAcceptingTerms } from '@app/contact-profile/store/contact-profile.reducers';
import { Observable } from 'rxjs';


@Component({
    selector: 'app-online-terms',
    templateUrl: './online-terms.component.html',
    styleUrls: ['./online-terms.component.scss'],
    animations: [pageAnimation]
})
export class OnlineTermsComponent implements OnInit {

    @HostBinding('@pageAnimation') animate = true;
    description: string;
    applicationConstants: any;
    contactForm: UntypedFormGroup;
    isUpdatingTerms: boolean;
    isAcceptingTerms$: Observable<boolean>;

    constructor(private fb: UntypedFormBuilder,
        private auth: AuthService,
        private router: Router,
        private store: Store<fromApp.AppState>) {
    }

    ngOnInit() {
        this.initUI();
        this.initForm();
        this.isAcceptingTerms$ = this.store.select(getIsAcceptingTerms);
    }

    onContinue() {

        // update the validation of all address controls
        this.markFormGroupDirtyTouched(this.contactForm);

        if (!this.contactForm.valid) {
            return;
        }
        this.isUpdatingTerms = true;

        // Use the new AcceptTermsAndConditions action
        this.store.dispatch(new AcceptTermsAndConditions());

        // Handle navigation and state updates in the effect success handler
        this.store.dispatch(new ActionSettingsChangeHideMainMenu({ hideMainMenu: false }));
        this.store.dispatch(new SetLoggedInContactTCPortalAccepted(true));

        let url = this.auth.getAuthenticationURLEntry();
        const thisUrl = ONLINE_TERMS_URL;
        if (url === thisUrl) {
            url = '/';
        }
        this.router.navigate([url], { replaceUrl: true });
        this.auth.handleAuthenticationURLEntry();
    }

    onLogout() {
        this.auth.logoutAndNavigate('/');
    }

    private initUI() {
        this.applicationConstants = applicationConstants.ApplicationConstants;
        this.description = 'As part of our ongoing commitment to data security and privacy we require all customers accept our ' +
      'Online Terms & Conditions and Privacy Statement.';
        this.store.dispatch(new ActionSettingsChangeHideMainMenu({ hideMainMenu: true }));

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        )
            .subscribe((event: NavigationStart) => {
                // reset main menu when navigating away
                this.store.dispatch(new ActionSettingsChangeHideMainMenu({ hideMainMenu: false }));
            });
    }


    private initForm() {
        this.contactForm = this.fb.group({
            portalTcAccepted: [false, Validators.requiredTrue],
        });
    }

    /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
    private markFormGroupDirtyTouched(formGroup: UntypedFormGroup) {
        for (const key of Object.keys(formGroup.controls)) {
            if (formGroup.controls[key] instanceof UntypedFormGroup) {
                this.markFormGroupDirtyTouched.bind(this, formGroup.controls[key]);
            }
            formGroup.controls[key].markAsDirty();
            formGroup.controls[key].updateValueAndValidity();
        }
        formGroup.markAllAsTouched();
    }

}
